import { render } from "./RowInfoIdea.vue?vue&type=template&id=1a260800"
import script from "./RowInfoIdea.vue?vue&type=script&lang=js"
export * from "./RowInfoIdea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__